module.exports = __webpack_public_path__ + "static/media/adaptive-led-headlamp.c9b09ff9.jpg";